import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { string, sentry } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import messages from './messages'


const GlobalHelmet = ({ intl, gender, pathname }) => {
  const isCorrectGender = ['male', 'female'].includes(gender)

  if (!isCorrectGender) {
    sentry.captureException('Not correct gender in GlobalHelmet', {
      extra: { gender, pathname },
    })
  }

  const genderMessages  = isCorrectGender ? messages[gender] : messages.female
  const title           = intl.formatMessage(genderMessages.title)
  const description     = string.multiLineToOneLine(
    intl.formatMessage(genderMessages.description)
  )

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`https://cdn.scentbird.com/facebook_${gender}_v2.jpg`} />
      <link rel="canonical" href={`https://www.scentbird.com${pathname}`} />
    </Helmet>
  )
}

GlobalHelmet.propTypes = {
  intl: PropTypes.object.isRequired,
  gender: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
}

export default injectIntl(GlobalHelmet)
